import { Filter, FilterType } from '@dfl/mui-admin-layout';
import { ESTABLISHMENTS_LIST_KEY } from 'modules/client/establishment/constants';
import { CLIENTS_LIST_KEY } from 'modules/client/management/constants';
import { ClientService } from 'modules/client/management/services';
import { AREAS_LIST_KEY } from 'modules/settings/nomenclatures/area/constants';
import AreaService from 'modules/settings/nomenclatures/area/services/area.service';
import i18n from 'settings/i18n';
import { AuditStatus } from '../interfaces';

const statuses = [
  { value: AuditStatus.COMPLETED, label: i18n.t('audit:statusName.COMPLETED'), translate: true },
  { value: AuditStatus.IN_PROGRESS, label: i18n.t('audit:statusName.IN_PROGRESS'), translate: true },
  { value: AuditStatus.DRAFT, label: i18n.t('audit:statusName.DRAFT'), translate: true },
];

export const clientFilter: Filter = {
  fetchFunc: ClientService.searchClients,
  filter: 'common:client',
  translate: true,
  type: FilterType.DYNAMIC_LIST,
  queryKey: CLIENTS_LIST_KEY,
  key: 'clients',
  field: 'client',
};

export const establishmentFilter: Filter = {
  fetchFunc: ClientService.searchEstablishments,
  filter: 'audit:fields.establishment',
  translate: true,
  type: FilterType.DYNAMIC_LIST,
  queryKey: ESTABLISHMENTS_LIST_KEY,
  key: 'establishments',
  field: 'establishment',
};
export const areaFilter: Filter = {
  fetchFunc: AreaService.search,
  filter: 'audit:fields.areas',
  translate: true,
  type: FilterType.DYNAMIC_LIST,
  queryKey: AREAS_LIST_KEY,
  key: 'areas',
  field: 'areas',
};

export const statusFilter: Filter = {
  filter: 'common:status.title',
  translate: true,
  type: FilterType.FIXED_LIST,
  key: 'status',
  field: 'status',
  options: statuses.map(({ value, label }) => ({ value, label })),
};

export const auditFilters = [clientFilter, establishmentFilter, areaFilter, statusFilter];
